import React from 'react';

import { Checkbox, type CheckboxChangeEvent } from '../Checkbox/Checkbox';

import { type TableResourceRecord, type TableSelectionConfig } from './Table.types';

import styles from './Table.module.scss';

export interface TableSelectionControlProps<RecordType> {
    selection: TableSelectionConfig<RecordType>;
    record: RecordType;
    dataSource: RecordType[];
}

const TableSelectionControl = <RecordType extends TableResourceRecord = any>({
    selection,
    record,
    dataSource
}: TableSelectionControlProps<RecordType>) => {
    const { selectedRowKeys, onChange } = selection;
    const { key: recordKey } = record || {};

    const handleSelectRow = (e: CheckboxChangeEvent) => {
        const { checked } = e.target;
        const newSelectedRowKeys = checked
            ? [...selectedRowKeys, recordKey]
            : selectedRowKeys.filter((key) => key !== recordKey);
        const selectedRows = dataSource.filter((row) => newSelectedRowKeys.includes(row.key));
        onChange(newSelectedRowKeys, selectedRows);
    };

    return (
        <div className={styles.tableSelectionControl}>
            <Checkbox checked={selectedRowKeys.includes(recordKey)} onChange={handleSelectRow} />
        </div>
    );
};

export default TableSelectionControl;
